module.exports = __webpack_public_path__ + "img/pijl-driehoek-home-desktop.9212b55608791497371c69fb46ed7723.svg";